import { useEffect, useState } from "react";
import { LockKeyhole } from "lucide-react";
import { api } from "../api";
import { Button, Card } from "../components/Ui";

export function AdminLoginPage({
  onSuccess,
}: {
  onSuccess(): Promise<unknown>;
}) {
  const [error, setError] = useState("");
  const [challenge, setChallenge] = useState<{
    id: string;
    botUrl: string;
  } | null>(null);
  const loginWithBot = async () => {
    setError("");
    try {
      const created = await api.createAdminChallenge();
      setChallenge(created);
      window.open(created.botUrl, "_blank", "noopener,noreferrer");
    } catch (caught) {
      setError(
        caught instanceof Error ? caught.message : "Не удалось создать вход",
      );
    }
  };
  useEffect(() => {
    if (!challenge) return;
    let polling = false;
    const timer = window.setInterval(async () => {
      if (polling) return;
      polling = true;
      try {
        const result = await api.consumeAdminChallenge(challenge.id);
        if (result.approved && result.sessionToken) {
          window.localStorage.setItem("s168_session", result.sessionToken);
          window.sessionStorage.setItem(
            "s168_admin_session",
            result.sessionToken,
          );
          window.clearInterval(timer);
          await onSuccess();
        }
      } catch (caught) {
        const message =
          caught instanceof Error ? caught.message : "Ошибка входа";
        if (!message.includes("истекла") && !message.includes("использована"))
          return;
        window.clearInterval(timer);
        setError(message);
        setChallenge(null);
      } finally {
        polling = false;
      }
    }, 2000);
    return () => window.clearInterval(timer);
  }, [challenge, onSuccess]);
  return (
    <main className="admin-login">
      <Card>
        <div className="login-icon">
          <LockKeyhole />
        </div>
        <p className="eyebrow">SEREZHA168</p>
        <h1>Админ-панель</h1>
        <p>Войти может только владелец, указанный в настройках бота.</p>
        <Button onClick={loginWithBot} loading={Boolean(challenge)}>
          {challenge ? "Подтвердите вход в Telegram…" : "Войти через бота"}
        </Button>
        {error ? <p className="form-error">{error}</p> : null}
      </Card>
    </main>
  );
}
